import React, { useEffect, useState } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import apiUrl from "../../../Apiurl";
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import associaImmagineENomeANomeUtente from "../../../interfaccia/funzioniComuni/associaImmagineENomeANomeUtente";
import umanizzaDataSenzaSecondi from "../../../interfaccia/funzioniComuni/umanizzaDataSenzaSecondi";

function Timeline({ idSped }) {

    const [loading, setLoading] = useState(false);
    const [listaEventi, setListaEventi] = useState(false);

    ////////////////////       AUTENTICAZIONE      ///////////////////////////
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    useEffect(() => {
        const getUserMetadata = async () => {
            try {
                const accessToken = await getAccessTokenSilently();
                setToken(accessToken);
            } catch (e) {
                console.log(e.message);
            }
        };
        getUserMetadata();
    }, [getAccessTokenSilently, user?.sub]);
    //////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        const fetchTimeline = async () => {
            setLoading(true);
            const nuoviParams = new URLSearchParams({
                idSped: idSped
            })
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                }
            }
            const response = await axios.get(apiUrl + "/logistica/ordine/getTimeline?" + nuoviParams, config);
            setListaEventi(response.data);
            setLoading(false);
        };
        fetchTimeline()
    }, [token, idSped]);


    function contenutoEvento(evento, nomeDisplay) {
        if (evento.tipo === "magazzinoArticolo") return <div><strong>{evento.nomeUtente} · Magazzino</strong>
          <p>Articolo {evento.idArticolo}, pezzo {evento.idUnita}: {evento.valorePrima || "—"} → {evento.statoMagazzino || "—"} ({evento.metodo})</p>
          <p>{evento.dettaglioMagazzino?.descrizione}</p><p>{evento.dettaglioMagazzino?.barcode && `Matricola: ${evento.dettaglioMagazzino.barcode}`}
          {evento.dettaglioMagazzino?.barcode_prodotto && ` · Prodotto: ${evento.dettaglioMagazzino.barcode_prodotto}`}</p><p>{evento.dettaglioMagazzino?.motivo}</p></div>;
        if (evento.tipo === "nota") {
            return (
                <div>
                    <small><strong>{nomeDisplay}</strong> dice:</small>
                    <div className="mt2">{evento.contenuto}</div>
                    <small className="mt2">{evento.funzione ?? evento.funzione}</small>
                </div>
            )
        }
        if (evento.tipo === "modificaOrdine") {
            if (evento.campoModifica === "articoliArr") {
                return(
                    <div>
                    <small><strong>{nomeDisplay}</strong> ha cambiato:</small>
                    <div className="b mt2">{evento.campoModifica}</div>
                    <div className="mt2">ha pasticciato qualcosa negli articoli</div>
                    <small className="mt2">{evento.funzione ?? evento.funzione}</small>
                    </div>
                )
            }
            if (evento.campoModifica === "resiErimborsiArr") {
                return(
                    <div>
                    <small><strong>{nomeDisplay}</strong> ha cambiato:</small>
                    <div className="b mt2">{evento.campoModifica}</div>
                    <div className="mt2">ha pasticciato qualcosa nei resi</div>
                    <small className="mt2">{evento.funzione ?? evento.funzione}</small>
                    </div>
                )
            }
            return (
                <div>
                    <small><strong>{nomeDisplay}</strong> ha cambiato:</small>
                    <div className="b mt2">{evento.campoModifica}</div>
                    <div className="mt2">da {evento.valorePrima} a <strong>{evento.valoreDopo}</strong></div>
                    <small className="mt2">{evento.funzione ?? evento.funzione}</small>
                </div>
            )
        }
        if (evento.tipo === "cambioStatoOMag") {
            return (
                <div>
                    <small><strong>{nomeDisplay}</strong> ha impostato:</small>
                    <div className="b mt2 f4">{evento.statoOrdine}</div>
                    <div className="mt2 mb2 ttu b">{evento.partenzaDa}</div>
                    <small className="mt2">{evento.funzione ?? evento.funzione}</small>
                </div>
            )
        }
        if (evento.tipo === "statoPrestashop") {
            return (
                <div>
                    <small><strong>{nomeDisplay || "Timeline automatica"}</strong> ha impostato su Prestashop:</small>
                    <div className="b mt2 f4">
                        {evento.statoPrestashopLabel} ({evento.statoPrestashopId})
                    </div>
                    <div className="mt2">
                        per l&apos;ordine PS <strong>{evento.idPrestashop}</strong>
                    </div>
                    {evento.idSpedCausalePrestashop && (
                        <div className="mt2">
                            perche la spedizione ID <strong>{evento.idSpedCausalePrestashop}</strong>
                            {evento.partenzaDaCausalePrestashop && (
                                <> con partenza da <strong>{evento.partenzaDaCausalePrestashop}</strong></>
                            )}
                            {evento.statoSpedizioneCausalePrestashop && (
                                <> e in stato <strong>{evento.statoSpedizioneCausalePrestashop}</strong></>
                            )}
                            .
                        </div>
                    )}
                    {evento.statoPrestashopSpiegazione && (
                        <div className="mt2">{evento.statoPrestashopSpiegazione}</div>
                    )}
                    <small className="mt2">
                        {evento.funzione ?? evento.funzione}
                        {evento.esitoPrestashop ? ` - ${evento.esitoPrestashop}` : ""}
                    </small>
                </div>
            )
        }
        if (evento.tipo === "prenotazioneModa") {
            const articoloLabel = evento.codVSModa
                ? `articolo ${evento.codVSModa}`
                : evento.idArticoloModa
                    ? `articolo ID ${evento.idArticoloModa}`
                    : "articolo";
            const dettaglio = evento.dettaglioModa || {};
            return (
                <div>
                    <div className="b mb2">{articoloLabel}</div>
                    {evento.descrizioneArticoloModa && (
                        <small className="db mb2">{evento.descrizioneArticoloModa}</small>
                    )}
                    <small><strong>Timeline automatica</strong> ha registrato da Moda:</small>
                    <div className="b mt2 f5">{evento.tipoEventoModa}</div>
                    {evento.campoModa && (
                        <div className="mt2">
                            {evento.campoModa}: {evento.valorePrimaModa || "-"} {" -> "}
                            <strong>{evento.valoreDopoModa || "-"}</strong>
                        </div>
                    )}
                    {(evento.idSpedOrigineModa || evento.idSpedDestinazioneModa) && (
                        <div className="mt2">
                            Spedizione origine: <strong>{evento.idSpedOrigineModa || "-"}</strong>
                            {" - "}
                            destinazione: <strong>{evento.idSpedDestinazioneModa || "-"}</strong>
                        </div>
                    )}
                    {dettaglio.messaggio && (
                        <div className="mt2">{dettaglio.messaggio}</div>
                    )}
                    {dettaglio.motivo && (
                        <div className="mt2">{dettaglio.motivo}</div>
                    )}
                    {dettaglio.magPrenotazione && (
                        <div className="mt2">
                            Mag prenotazione: <strong>{dettaglio.magPrenotazione}</strong>
                        </div>
                    )}
                    {dettaglio.statoDestinazione && (
                        <div className="mt2">
                            Stato destinazione: <strong>{dettaglio.statoDestinazione}</strong>
                        </div>
                    )}
                    <small className="mt2">{evento.funzione ?? evento.funzione}</small>
                </div>
            )
        }
    }

    function stileEvento(evento) {

        let { nomeDisplay, pathImmagine } = associaImmagineENomeANomeUtente(evento.nomeUtente, user.name, 150);
        let position = evento.nomeUtente === user.name ? 'right' : 'left'
        let contentStyle = { "background-color": "var(--colChiaro)", color: 'black', "border-top": "3px solid var(--colScuro)" }
        let contentArrowStyle = { borderRight: '7px solid var(--colChiaro)' }
        let dataEvento = umanizzaDataSenzaSecondi(evento.dataEvento);
        let dateClassName = "mr3 ml3 black"
        let iconStyle = { background: '#FFDFDF' }
        let icon = pathImmagine ? <img className="br-100" src={pathImmagine} alt="" /> : ""
        let content = <div className="f5">{contenutoEvento(evento, nomeDisplay)}</div>

        if (evento.tipo === "cambioStatoOMag") {
            switch (evento.statoOrdine) {
                case "IN ATTESA":
                    contentStyle = {
                        "background-color": "var(--colAttesa)",
                        color: ' var(--colScrittaAttesa)',
                        "border-top": "3px solid var(--colScuro)"
                    }
                    contentArrowStyle = { borderRight: '7px solid var(--colAttesa)' }
                    break;
                case "SPEDITO":
                    contentStyle = {
                        "background-color": "var(--colSpedito)",
                        color: ' var(--colScrittaSpedito)',
                        "border-top": "3px solid var(--colScuro)"
                    }
                    contentArrowStyle = { borderRight: '7px solid var(--colSpedito)' }
                    break;
                case "PREPARAZIONE":
                    contentStyle = {
                        "background-color": "var(--colPreparazione)",
                        color: ' var(--colScrittaPreparazione)',
                        "border-top": "3px solid var(--colScuro)"
                    }
                    contentArrowStyle = { borderRight: '7px solid var(--colPreparazione)' }
                    break;
                case "ETICHETTE":
                    contentStyle = {
                        "background-color": "var(--colEtichette)",
                        color: ' var(--colScrittaEtichette)',
                        "border-top": "3px solid var(--colScuro)"
                    }
                    contentArrowStyle = { borderRight: '7px solid var(--colEtichette)' }
                    break;
                case "PRONTO EXP":
                    contentStyle = {
                        "background-color": "var(--colProntoExp)",
                        color: ' var(--colScrittaProntoExp)',
                        "border-top": "3px solid var(--colScuro)"
                    }
                    contentArrowStyle = { borderRight: '7px solid var(--colProntoExp)' }
                    break;
                case "ANNULLATO":
                    contentStyle = {
                        "background-color": "var(--colAnnullato)",
                        color: ' var(--colScrittaAnnullato)',
                        "border-top": "3px solid var(--colScuro)"
                    }
                    contentArrowStyle = { borderRight: '7px solid var(--colAnnullato)' }
                    break;
                case "RESO":
                    contentStyle = {
                        "background-color": "var(--colReso)",
                        color: ' var(--colScrittaReso)',
                        "border-top": "3px solid var(--colScuro)"
                    }
                    contentArrowStyle = { borderRight: '7px solid var(--colReso)' }
                    break;
                case "RICERCA":
                    contentStyle = {
                        "background-color": "var(--colRicerca)",
                        color: ' var(--colScrittaRicerca)',
                        "border-top": "3px solid var(--colScuro)"
                    }
                    contentArrowStyle = { borderRight: '7px solid var(--colRicerca)' }
                    break;
                    case "TROVATO":
                        contentStyle = {
                            "background-color": "var(--colTrovato)",
                            color: ' var(--colScrittaTrovato)',
                            "border-top": "3px solid var(--colScuro)"
                        }
                        contentArrowStyle = { borderRight: '7px solid var(--colTrovato)' }
                        break;
                default:
                    break;
            }
        }

        if (evento.tipo === "statoPrestashop") {
            position = "left"
            contentStyle = {
                "background-color": "#eef4ff",
                color: "#001B44",
                "border-top": "3px solid #001B44"
            }
            contentArrowStyle = { borderRight: '7px solid #eef4ff' }
            iconStyle = { background: '#d8e7ff' }
        }

        if (evento.tipo === "prenotazioneModa") {
            position = "left"
            contentStyle = {
                "background-color": "#fff7e6",
                color: "#332100",
                "border-top": "3px solid #8a5a00"
            }
            contentArrowStyle = { borderRight: '7px solid #fff7e6' }
            iconStyle = { background: '#ffe0a3' }
        }

        return (
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                position={position}
                contentStyle={contentStyle}
                contentArrowStyle={contentArrowStyle}
                date={dataEvento}
                dateClassName={dateClassName}
                iconStyle={iconStyle}
                icon={icon}
            >
                {content}
            </VerticalTimelineElement>
        )
    }


    if (loading) {
        return <div>caricamento...</div>
    } else if (listaEventi) {
        return (
            <div className="timeline sezioneConScroll h-100 w-100">
                <VerticalTimeline
                    lineColor={"#001B44"}
                >
                    {listaEventi.map(evento => evento.campoModifica !== "noteArr" && stileEvento(evento))}
                </VerticalTimeline>
            </div>
        )
    } else {
        return <p>.</p>
    }
}

export default Timeline;
